export const sanitizeCSVValue = (value) => {
    if (value === null || value === undefined) return '';
    const str = String(value);
    if (/^[=+\-@\t\r]/.test(str)) {
        return `'${str}`;
    }
    return str;
}


export const sanitizeExportData = (dataArray) => {
    if (!Array.isArray(dataArray)) return dataArray;
    return dataArray.map(row => {
        if (typeof row !== 'object' || row === null) return row;
        const sanitizedRow = {};
        Object.keys(row).forEach(key => {
            sanitizedRow[key] = sanitizeCSVValue(row[key]);
        });
        return sanitizedRow;
    });
};

